import { RoomFlagNames, RoomFlags } from '../types';

export function checkRoomFlag(flags: number, toCheck: RoomFlagNames | RoomFlagNames[]) {
  if (!Array.isArray(toCheck)) {
    toCheck = [toCheck];
  }

  return toCheck.every(flagName => {
    const key = flagName.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(RoomFlagNames, key)) {
      return (flags & RoomFlags[key]) === RoomFlags[key];
    }
    return false;
  });
}

export function setRoomFlag(flags: number, toSet: RoomFlagNames | RoomFlagNames[]) {
  if (!Array.isArray(toSet)) {
    toSet = [toSet];
  }

  toSet.forEach(flagName => {
    const key = flagName.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(RoomFlagNames, key)) {
      flags |= RoomFlags[key];
    }
  });

  return flags;
}

export function unsetRoomFlag(flags: number, toUnset: RoomFlagNames | RoomFlagNames[]) {
  if (!Array.isArray(toUnset)) {
    toUnset = [toUnset];
  }

  toUnset.forEach(flagName => {
    const key = flagName.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(RoomFlagNames, key)) {
      flags &= ~RoomFlags[key];
    }
  });

  return flags;
}
